import {
  Workshop,
  WorkshopV2,
  BookingMode,
  WorkshopType,
} from '../interfaces/workshop.interface';

/**
 * Convertit un workshop V1 en format V2
 * Règles de mapping pour bookingMode :
 * - subtype 'duo' → BookingMode.DUO
 * - autres (beginner, advanced, null) → BookingMode.SOLO
 */
export function mapV1toV2(workshop: Workshop): Omit<WorkshopV2, 'id'> {
  let bookingMode: BookingMode;

  if (workshop.subtype === 'duo') {
    bookingMode = BookingMode.DUO;
  } else {
    bookingMode = BookingMode.SOLO;
  }

  // Conversion du prix V1 vers priceSolo/priceDuo
  const priceSolo = bookingMode === BookingMode.DUO ? 0 : workshop.price;
  const priceDuo = bookingMode === BookingMode.DUO ? workshop.price : 0;

  return {
    title: workshop.title,
    description: workshop.description,
    type: workshop.type,
    date: workshop.date,
    duration: workshop.duration,
    location: workshop.location,
    bookingMode,
    priceSolo,
    priceDuo,
    maxParticipants: workshop.maxParticipants,
    remainingPlaces: workshop.remainingPlaces,
    imageUrl: workshop.imageUrl,
    active: workshop.active,
    createdBy: workshop.createdBy,
    createdAt: workshop.createdAt,
  };
}

/**
 * Labels français pour BookingMode
 */
export const getBookingModeLabel = (mode: BookingMode): string => {
  switch (mode) {
    case BookingMode.SOLO:
      return 'Individuel';
    case BookingMode.DUO:
      return 'Duo';
    case BookingMode.SOLO_DUO:
      return 'Individuel ou Duo';
    default:
      return mode;
  }
};

/**
 * Labels français pour WorkshopType
 */
export const getTypeLabel = (type: WorkshopType): string => {
  switch (type) {
    case 'public':
      return 'Tout public';
    case 'health':
      return 'Santé';
    case 'teambuilding':
      return 'Teambuilding';
    default:
      return type;
  }
};
